<template>
<v-container>
  <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>

  <template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" style="color:white;">
            Water Flow Sensor Label
          </th>
           <th class="text-left" style="color:white;">
            Water Flow Sensor S/N
          </th>
          <th class="text-left" style="color:white;">
            Location
          </th>
          <th class="text-left" style="color:white;">
            Outlet Type
          </th>
 
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in waterBoard"
          :key="item.waterFlowConsole"
        >
          <td>{{ item.waterFlowConsole1 }}</td>
          <td>{{ item.waterFlowSn1 }}</td>
          <td>{{ item.locationRemarks1 }}</td>
          <td>{{ item.item1.map(({item}) => item + ' ' ).join('+ ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in waterBoard"
          :key="item.waterFlowConsole"
        >
          <td>{{ item.waterFlowConsole2 }}</td>
          <td>{{ item.waterFlowSn2 }}</td>
          <td>{{ item.locationRemarks2 }}</td>
          <td>{{ item.item2.map(({item}) => item + ' ' ).join('+ ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in waterBoard"
          :key="item.waterFlowConsole"
        >
          <td>{{ item.waterFlowConsole3 }}</td>
          <td>{{ item.waterFlowSn3 }}</td>
          <td>{{ item.locationRemarks3 }}</td>
          <td>{{ item.item3.map(({item}) => item + ' ' ).join('+ ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in waterBoard"
          :key="item.waterFlowConsole"
        >
          <td>{{ item.waterFlowConsole4 }}</td>
          <td>{{ item.waterFlowSn4 }}</td>
          <td>{{ item.locationRemarks4 }}</td>
          <td>{{ item.item4.map(({item}) => item + ' ' ).join('+ ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in waterBoard"
          :key="item.waterFlowConsole"
        >
          <td>{{ item.waterFlowConsole5 }}</td>
          <td>{{ item.waterFlowSn5 }}</td>
          <td>{{ item.locationRemarks5 }}</td>
          <td>{{ item.item5.map(({item}) => item + ' ' ).join('+ ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in waterBoard"
          :key="item.waterFlowConsole"
        >
          <td>{{ item.waterFlowConsole6 }}</td>
          <td>{{ item.waterFlowSn6 }}</td>
          <td>{{ item.locationRemarks6 }}</td>
          <td>{{ item.item6.map(({item}) => item + ' ' ).join('+ ') }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <!-- <p>{{loadTypeA}}</p> -->
   
</template>
<v-btn fixed dark fab bottom right color="green" :to="{ name: 'Water Edit', params: { id: this.$route.params.id } }">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
</v-container>
</template>

<script>
import axios from "axios";

  export default {
    data () {
      return {
        items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Water Flow',
          disabled: false,
          href: '/water-board',
        },
        {
          text: 'Details',
          disabled: true,
          href: '',
        },
      ],
        waterBoard: []
      }
    },
    mounted() {
    this.loadsWaterBoard();
  },
    methods:{
      loadsWaterBoard: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/water-board/" + this.$route.params.id;
      axios.get(apiURL).then(res => {
      this.waterBoard = res.data;
      }).catch(error => {
      console.log(error)
      });
},
    }
  }
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>